//@flow
import styled from "styled-components"
import theme from "../Theme"

const FormCol = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: ${props => props.grow};
  flex-basis: 10rem;

  & + * {
    margin-left: 1rem;
  }
`

FormCol.defaultProps = { theme }

export default FormCol



// WEBPACK FOOTER //
// ./src/UI/Form/FormCol.js